import { CommonModule } from '@angular/common';
import { Component,Inject } from '@angular/core';
import { FormArray,FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from '../../../../../dave-utils-module/app-button-module/app-button.module';
import { NumberTransformInputComponent } from '../../../../../number-transform-input/number-transform-input.component';
import { arlBaseCostAllowanceFormGroup, getARLBaseCostAllowanceForm } from '../../arl-form-data.service';
import { ArlAllowanceDialogComponentDialogData } from '../arl-allowance-dialog/arl-allowance-dialog.component';
import { ArlChargeDialogBase } from './ArlChargeDialogBase';

export type ArlChargeDialogComponentDialogReturnData = undefined;
export interface ArlChargeDialogComponentDialogData {
    arlChargeFormArray: FormArray<arlBaseCostAllowanceFormGroup>;
}
@Component({
    selector: 'app-arl-charge-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FontAwesomeModule,
        MatLegacyFormFieldModule,
        FormsModule,
        MatLegacyInputModule,
        MatLegacyListModule,
        MatLegacyButtonModule,
        MatLegacyTooltipModule,
        ReactiveFormsModule,
        MatLegacyDialogModule,
        AppButtonModule,
    ],
    templateUrl: './arl-charge-dialog.component.html',
    styleUrls: ['./arl-charge-dialog.component.scss'],
})
export class ArlChargeDialogComponent extends ArlChargeDialogBase {
    protected filterAllowanceCharges(form: arlBaseCostAllowanceFormGroup): boolean {
        return !form.value.arlType && (form.value.percent || 0) >= 0
    }
    constructor(@Inject(MAT_DIALOG_DATA) dialogData: ArlChargeDialogComponentDialogData) {
        super(dialogData.arlChargeFormArray);
    }
    addClick() {
        this.add(getARLBaseCostAllowanceForm(
            {
                title: null,
                percent: null,
                arlType: null,
            },
            'surcharge'
        ));
    }
}
